import React from 'react';
import {Page, Text, View, Image} from '@react-pdf/renderer';
import {imagePath} from "../../utils/imageUtils";
import {convertYMDtoDMY} from "../../utils/dateTimeUtils";
import {BarCode, BottomBorderBox, CFCLabeledText, Column, Columns} from "./pdf_common";
import { getBoardingPassImage } from '../../utils/themeUtils';
import { getTranslation } from '../../utils/translationUtils';
import {getPrimaryBrandColor} from "../../utils/themePdfUtils";


function CFCBoardingPassPage(props) {
    return (
        <Page size="A4" style={{
            flexDirection: 'column',
            backgroundColor: 'white',
            fontFamily: "pdfFont",
        }}>
            <Image src={imagePath(getBoardingPassImage())} style={{width: "42%", margin: "0 auto", paddingTop: "12px", height: "auto"}}/>
            <View style={{
                padding: "18px 36px 36px 36px",
                fontSize: "10.5px",
                flex: 1,
                display: "flex",
            }}>
                <BottomBorderBox>
                    <Text style={{
                        fontSize: "25px",
                        color: getPrimaryBrandColor(),
                        letterSpacing: "3px",
                    }}>
                        CARTE D’EMBARQUEMENT
                    </Text>
                </BottomBorderBox>

                <BottomBorderBox>
                    <BarCode number={props.passenger.boardingPassCode} />
                </BottomBorderBox>

                <BottomBorderBox>
                    <Columns>
                        <Column>
                            <CFCLabeledText label="Référence de réservation" value={props.bookingData.bookingReference} />
                            <CFCLabeledText label="Nom du passager" value={`${props.passenger.title} ${props.passenger.firstName} ${props.passenger.lastName}`} />
                        </Column>
                        <Column>
                            <CFCLabeledText label="Code croisière" value={props.bookingData.itineraryCode} />
                            <CFCLabeledText label="Nom de la croisière" value={props.bookingData.itineraryName} />
                        </Column>
                    </Columns>
                </BottomBorderBox>

                <BottomBorderBox>
                    <Columns>
                        <Column>
                            <CFCLabeledText label="Nom du navire" value={props.bookingData.shipName} />
                            <CFCLabeledText label="Numéro de pont" value={props.passenger.deckNumber} />
                        </Column>
                        <Column>
                            <CFCLabeledText label="Numéro de cabine" value={props.passenger.cabinNumber} />
                            <CFCLabeledText label="Catégorie de cabine" value={props.passenger.cabinCategory} />
                        </Column>
                    </Columns>
                </BottomBorderBox>

                <BottomBorderBox>
                    <Columns>
                        <Column>
                            <CFCLabeledText label="Date d'embarquement" value={convertYMDtoDMY(props.bookingData.embarkationDate)} />
                            <CFCLabeledText label="Heure d'embarquement" value={props.passenger.embarkationTime} />
                            <CFCLabeledText label="Port d'embarquement" value={getTranslation(props.bookingData.departurePort)} />
                        </Column>
                        <Column>
                            <CFCLabeledText label="Date de débarquement" value={convertYMDtoDMY(props.bookingData.disembarkationDate)} />
                            <CFCLabeledText label="Heure de fermeture de l'embarquement" value={props.passenger.embarkationClosingTime} />
                            <CFCLabeledText label="Port de débarquement" value={getTranslation(props.bookingData.arrivalPort)} />
                        </Column>
                    </Columns>
                    <CFCLabeledText label="Adresse du terminal d'embarquement" value={props.bookingData.shipBerthed}/>
                </BottomBorderBox>

                <BottomBorderBox>
                    <CFCLabeledText
                    label="Numéro en cas d'urgence"
                    value="Du Lundi au Vendredi de 9h à 18h30 et le Samedi de 9h30 à 17h au +33 (0) 801 34 22 22 ou par e-mail: mareservation@ambassadorcroisieres.fr"
                    />

                    <CFCLabeledText label="Service d’assistance pour les jours d’embarquement" value="+33 (0) 6 18 46 47 57"/>

                    <CFCLabeledText label="Numéro du navire" value={props.bookingData.shipPhone}/>
                </BottomBorderBox>

                {/* this 8px needs to stay in line with BottomBorderBox margin */}
                <View style={{marginTop: "8px"}}>
                    <CFCLabeledText style={{margin: "3px 0 0"}} label="Notes supplémentaires" value={props.bookingData?.notes?.PickupInstruction} />
                </View>

            </View>
            <View style={{display:"flex", alignItems:"center", marginTop: "0px"}}>
                {/* We can extract the footer_mage_url into a util function */}
                <Image src={imagePath('cfc_boarding_pass_footer.png')} style={{width: "100%", height: "auto"}} />
            </View>
        </Page>
    );
}

export default CFCBoardingPassPage;